
import Vue from 'vue'
import Swal from 'sweetalert2'
import { noop } from 'lodash'
import DialogIdentityExport from '~/components/Dialog/Identity/Export.vue'
import DialogIdentityImport from '~/components/Dialog/Identity/Import.vue'
import DialogIdentityCreate from '~/components/Dialog/Identity/Create.vue'

export default Vue.extend({
  data: () => ({
  }),

  methods: {
    openIdentityExportDialog() {
      this.$modal.show(DialogIdentityExport)
    },

    openIdentityImportDialog() {
      this.$modal.show(DialogIdentityImport)
    },

    openIdentityCreateDialog(ask = true) {
      if (ask) {
        Swal.fire({
          icon: 'warning',
          title: 'Are you sure you want to get a new identity?',
          text: 'You will lose administrator access to your databases, boards and you will have to share your new identity with people you trust.',
          confirmButtonText: 'Yes',
          confirmButtonColor: '#BF616A',
          showCancelButton: true
        }).then((value) => {
          if (value.isConfirmed) {
            this.$modal.show(DialogIdentityCreate)
          }

          return value
        }).catch(noop)
      } else {
        this.$modal.show(DialogIdentityCreate)
      }
    },

    resetIdentity() {
      Swal.fire({
        icon: 'warning',
        title: 'Are you sure you want to get a new identity?',
        text: 'You will lose administrator access to your databases, boards and you will have to share your new identity with people you trust.',
        confirmButtonText: 'Yes',
        confirmButtonColor: '#BF616A',
        showCancelButton: true
      }).then((value) => {
        if (value.isConfirmed) {
          this.doResetIdentity()
        }

        return value
      }).catch(noop)
    },

    async doResetIdentity() {
      Swal.fire({
        title: 'Generating a new identity...',
        text: 'It won\'t take long.',
        showCancelButton: false,
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false
      })

      await this.$accessor.ipfs.resetIdentity()
    },

    exportPublicKey() {
      if (!this.$ipfs.publicKey) {
        return
      }

      this.$ipfs.publicKey.download()
    },

    reset() {
      Swal.fire({
        icon: 'warning',
        title: 'Are you sure you want to delete everything?',
        text: 'Your files, settings and identity will be lost forever.',
        confirmButtonText: 'Yes',
        confirmButtonColor: '#BF616A',
        showCancelButton: true
      }).then((value) => {
        if (value.isConfirmed) {
          this.doReset()
        }

        return value
      }).catch(noop)
    },

    async doReset() {
      Swal.fire({
        title: 'Resetting the timeline...',
        text: 'One moment please.',
        showCancelButton: false,
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false
      })

      // Unpin all and empty storage.
      await this.$accessor.pins.unpinAll()
      await this.$accessor.ipfs.freeUpStorage()

      // Reset settings
      await this.$accessor.settings.reset()

      Swal.close()

      this.openIdentityCreateDialog(false)
    }
  }
})
